/* ─────────────────────────────────────────────────────────────────────────────
 *  peopleAlsoAsk.ts — PAA questions for search results
 * ───────────────────────────────────────────────────────────────────────────── */

export interface PAQuestion {
  question: string;
  answer: string;
}

export const PEOPLE_ALSO_ASK: PAQuestion[] = [
  {
    question: "What are your hobbies?",
    answer:
      "I enjoy reading fiction stories and philosophy. When I'm not reading for leisure, I spend my free time writing about random stuff. I also like listening to music, especially hip hop, R&B and drill.",
  },
  {
    question: "Are you open for work?",
    answer:
      "Yes. I am always open to work on innovative projects with creative teams.",
  },
  {
    question: "What's the fastest way to reach you?",
    answer:
      "Definitely email. Contact me at jasur@shukurov.me.",
  },
  {
    question: "What motivates you?",
    answer:
      "Meeting deadlines, targets or goals. Mentoring and coaching others, learning new things, coming up with creative ideas to improve something, and making something new.",
  },
  {
    question: "Is Jasur actually a wizard?",
    answer:
      "I do simple things, but some people call it magic.",
  },
  {
    question: "Why does this website look like Google?",
    answer:
      "Because if your portfolio isn't a multi-billion dollar search engine parody, are you even trying? Also, imitation is the sincerest form of flattery.",
  },
  {
    question: "How many mass is in the mass of the sun?",
    answer:
      "Exactly one. Next question.",
  },
  {
    question: "Can you mass produce mass production?",
    answer:
      "Only on Tuesdays, and only if you have a permit from the Department of Redundancy Department.",
  },
];
